import { styled } from '../../hooks/theme';
import { StepType } from './Stepper.types';

interface StepHeaderProps {
  state: StepType;
}

export const Container = styled.div`
  width: 100%;
`;

export const StepsHeader = styled.div`
  gap: 16px;
  padding: 32px;

  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const StepHeader = styled.div<StepHeaderProps>`
  display: flex;
  flex-direction: row;

  color: ${props =>
    props.state !== 'UNFINISHED'
      ? props.theme.colors.brand.primary[100]
      : props.theme.colors.neutral.grey[40]};
  border-color: ${props =>
    props.state !== 'UNFINISHED'
      ? props.theme.colors.brand.primary[100]
      : props.theme.colors.neutral.grey[40]};
`;

export const StepIconCircle = styled.div<StepHeaderProps>`
  width: 32px;
  height: 32px;
  margin-right: 8px;

  border: 1px solid;
  border-radius: 32px;

  display: flex;
  justify-content: center;
  align-items: center;

  color: ${props => props.state === 'CURRENT' && props.theme.colors.neutral.grey[0]};
  border-color: ${props => props.state === 'CURRENT' && props.theme.colors.brand.primary[100]};
  background: ${props => props.state === 'CURRENT' && props.theme.colors.brand.primary[100]};
`;

export const StepHeaderText = styled.div<StepHeaderProps>`
  color: ${props =>
    props.state === 'CURRENT'
      ? props.theme.colors.neutral.grey[100]
      : props.theme.colors.neutral.grey[40]};

  p {
    margin: 0;
    font-size: 14px;
  }
`;

export const StepHeaderTitle = styled.div<StepHeaderProps>`
  height: 32px;

  display: flex;
  align-items: center;

  color: ${props =>
    props.state !== 'UNFINISHED'
      ? props.theme.colors.neutral.grey[100]
      : props.theme.colors.neutral.grey[40]};
`;

export const StepHeaderDescription = styled.div``;

export const StepHeaderConnector = styled.div<StepHeaderProps>`
  height: 32px;
  margin-left: 16px;
  width: 93px;
  overflow: auto;

  &::after {
    content: '';
    height: 1px;
    background: ${props =>
      props.state === 'FINISHED'
        ? props.theme.colors.brand.primary[100]
        : props.theme.colors.neutral.grey[40]};
    display: block;
    position: relative;
    top: 50%;
  }
`;

export const StepContent = styled.div`
  width: 100%;
`;
